"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkTheme = void 0;
exports.default = {
    palette: {
        primary: {
            main: "#e64210",
            contrastText: "#fff"
        },
        secondary: {
            main: "#2C2F30"
        },
        error: {
            main: "#d0021b"
        }
    },
    overrides: {
        MuiCollapse: {
            entered: {
                overflow: "auto"
            }
        }
    }
};
exports.darkTheme = {
    palette: {
        type: "dark",
        primary: {
            main: "#e64210",
            contrastText: "#fff"
        },
        secondary: {
            main: "#2C2F30"
        },
        error: {
            main: "#F26D63"
        }
    }
};
